module.exports = __webpack_public_path__ + "img/icon.9da5eee0.png";